export default "__VITE_ASSET__CQCfPHJh__"